export abstract class AsyncState {
    loading: boolean = false;
    error: any = null;
}